import { useEffect, useState } from "react";
import Api from "../api/api";
import Loader from "../shared/loader";
import { Link } from 'react-router-dom';
import Pagination from "../shared/pagination";
import stringHelpers from "../../utilities/stringHelpers";
import arrayUtilities from "../../utilities/arrayUtilities";
import { toDateTimeString } from "../../utilities/dateUtilities";
import { SearchBarWithDebounce } from "../shared/searchBarWithDebounce";
import { FiltersModalTrigger } from "../shared/filtersModalTrigger";
import { AppliedFilterDisplay } from "../shared/appliedFilterDisplay";
import { KadoeDataFiltersModal } from "./filters-modals/KadoeDataFiltersModal";

const KadoeDataEnum = {
    "vrm": "VRM",
    "pcnReference": "PCN Reference",
    "enquiryDate": "Enquiry Date",
    "responseDate": "Response Date",
    "nameAddress": "Name / Address",
    "vehicle": "Vehicle",
}

export default function KadoeData(props) {

    const [kadoeData, setKadoeData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [kadoeSearch, setKadoeSearch] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [lastPage, setLastPage] = useState(false);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const getKadoeData = (searchQuery, from, to, pageNumber) => {
        setIsLoading(true);
        Api.getKadoeRequests(
            data => {
                setKadoeData(data);
                setIsLoading(false);
            },
            () => {
                setKadoeData(null);
                setIsLoading(false);
            },
            searchQuery,
            from, to, pageNumber, props.organisationId, props.token
        )
    }
    const changepageNumber = (num) => {
        getKadoeData(kadoeSearch, fromDate, toDate, num)
        setPageNumber(num);
    };
    const isLastPage = () => {
        if (kadoeData && kadoeData !== undefined) {
            setLastPage(false)
            setPageCount(Math.ceil(kadoeData.totalCount / 100));
            if (pageNumber + 1 >= Math.ceil(kadoeData.totalCount / 100)) {
                setLastPage(true)
            }
        }
    };
    useEffect(() => getKadoeData("", null, null, 0), [])
    useEffect(() => isLastPage(), [kadoeData]);

    const clearFilters = () => {
        setFromDate(null);
        setToDate(null);
        setAppliedFilters(null);
        setShowFilterPills(false);
        setPageNumber(0);
        getKadoeData(kadoeSearch, null, null, 0);
    }

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "From":
                setFromDate(null)
                getKadoeData(kadoeSearch, null, toDate, 0)
                break
            case "To":
                setToDate(null)
                getKadoeData(kadoeSearch, fromDate, null, 0)
                break
            case "Date Range":
                setFromDate(null)
                setToDate(null)
                getKadoeData(kadoeSearch, null, null, 0)
                break
            default:
                break
        }
        setPageNumber(0)

    }

    const handleRefresh = () => {
        getKadoeData(kadoeSearch, fromDate, toDate, pageNumber);
    }

    const contactDetails = (item) => {
        if (!stringHelpers.isNullOrEmpty(item.forename) || !stringHelpers.isNullOrEmpty(item.surname)) {
            return `${!stringHelpers.isNullOrEmpty(item.forename) ? item.forename + " " : ""}${!stringHelpers.isNullOrEmpty(item.surname) ? item.surname : ""}${!stringHelpers.isNullOrEmpty(item.address) ? ", " + item.address : ""}`
        }
        if (!stringHelpers.isNullOrEmpty(item.companyName)) {
            return `${item.companyName}${!stringHelpers.isNullOrEmpty(item.address) ? ", " + item.address : ""}`
        }
        return ""
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="mb-0">
                                Kadoe Requests
                            </h5>
                            <div className="d-flex align-items-center">
                                <div className='mr-2'>
                                    <SearchBarWithDebounce
                                        onSearchQueryChange={query => {
                                            setKadoeSearch(query);
                                            setPageNumber(0)
                                            getKadoeData(query, fromDate, toDate, 0)
                                        }}
                                    />
                                </div>
                                <div className='mr-2'>
                                    <FiltersModalTrigger onClick={() => setShowFiltersModal(true)} />
                                </div>
                                <button
                                    className="btn btn-primary btn-sm mr-1 ml-1 nowrap"
                                    onClick={handleRefresh}>
                                    <i className="fas fa-redo"></i> Refresh
                                </button>
                            </div>
                        </div>
                        {
                            showFilterPills && appliedFilters &&
                            <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                {
                                    Object.entries(appliedFilters).map(
                                        ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                        && <div className="mr-2" key={label}>
                                            <AppliedFilterDisplay
                                                label={label}
                                                onTextClick={() => setShowFiltersModal(true)}
                                                onCloseClick={closedLabel => {
                                                    clearFilterByLabel(closedLabel)
                                                    setAppliedFilters(prevState => {
                                                        const updatedFilters = { ...prevState }
                                                        if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                                                            updatedFilters.From = null
                                                            updatedFilters.To = null
                                                            updatedFilters["Date Range"] = null
                                                        } else {
                                                            updatedFilters[closedLabel] = null
                                                        }
                                                        const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                        return hasRemainingFilters ? updatedFilters : null
                                                    })
                                                }}
                                                value={value}
                                            />
                                        </div>
                                    )
                                }
                                {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                            </div>
                        }
                        {isLoading
                            ? <Loader />
                            : <div className="card-body bg-white border-top details-container p-0 overflow-auto">
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                    <thead className="bg-200 text-900">
                                        <tr>{ Object.values(KadoeDataEnum).map(value => <th>{ value }</th>) }</tr>
                                    </thead>
                                    <tbody>
                                        {
                                            !arrayUtilities.isNullOrEmpty(kadoeData?.items) && kadoeData?.items.map(item => {
                                                const breachUrl = `/organisation/${ props.organisationId }/breach/${ item.breachId }`
                                                return (
                                                    <tr key={ item.id } className={ item.errorDescription ? "table-danger" : "" }>
                                                        <td>
                                                            <Link to={ breachUrl } className="number-plate-link"><h6 className="mb-0 small-number-plate">{ item.vrm }</h6></Link>
                                                        </td>
                                                        <td><Link to={ breachUrl }><h6 className="m-0">{ item.pcnReference }</h6></Link></td>
                                                        <td>{ toDateTimeString(item.enquiryDate) }</td>
                                                        <td>{ toDateTimeString(item.responseDate) }</td>
                                                        {
                                                            !stringHelpers.isNullOrEmpty(item.errorDescription)
                                                                ? <td colSpan={ 2 }>{ item.errorDescription }</td>
                                                                : <>
                                                                    <td>{ contactDetails(item) }</td>
                                                                    <td>{ !stringHelpers.isNullOrEmpty(item.colour) ? item.colour : "" } { !stringHelpers.isNullOrEmpty(item.make) ? item.make : "" } { !stringHelpers.isNullOrEmpty(item.model) ? item.model : "" } </td>
                                                                </>
                                                        }
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }
                        <div className="d-flex justify-content-center row align-items-center pt-2">
                            <div className="col-auto align-items-center">
                                <Pagination totalResults={kadoeData?.totalCount} currentPage={pageNumber} changePageNumber={changepageNumber} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showFiltersModal &&
                <KadoeDataFiltersModal
                    showModal={showFiltersModal}
                    handleClose={() => setShowFiltersModal(false)}
                    handleConfirm={(draftFilters) => {
                        setFromDate(draftFilters.fromDate)
                        setToDate(draftFilters.toDate)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        setPageNumber(0)
                        getKadoeData(kadoeSearch, draftFilters.fromDate, draftFilters.toDate, 0)
                    }}
                    initialFromDate={fromDate}
                    initialToDate={toDate}
                    initialAppliedFilters={appliedFilters}
                    key="kadoe-data-filters-modal"
                />
            }
        </div>
    )
}
